import { LeafValidationMessage } from "./validation-message.component.js";
customElements.define("leaf-validation-message", LeafValidationMessage);
export {
  LeafValidationMessage
};
//# sourceMappingURL=validation-message.js.map
